import "./createCampaignCoverSkeleton.scss";

export default function CreateCampaignCoverSkeleton() {
  return (
    <div className="create-campaign-cover-skeleton-container">
      <div
        className="create-campaign-cover-skeleton"
        style={{ width: "30%", height: "25px" }}
      />
      <div
        className="create-campaign-cover-skeleton"
        style={{ width: "50%", height: "15px" }}
      />
      <hr style={{ width: "100%" }} />
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <div
          className="create-campaign-cover-skeleton"
          style={{ width: "30%", height: "25px" }}
        />
        <div
          className="create-campaign-cover-skeleton"
          style={{ width: "50%", height: "35px" }}
        />
      </div>
      <div
        className="create-campaign-cover-skeleton"
        style={{ width: "100%", height: "450px" }}
      />
      <div
        className="create-campaign-cover-skeleton"
        style={{ width: "100%", height: "35px" }}
      />
    </div>
  );
}
